import { merge } from 'lodash';
import type { ValueOf } from '../../types';
import { OVERRIDE_ENTRY_CONFIG } from '../constants';
import type { TransformedCmsConfigItemLevels, ExtendedTransformedCmsConfigItemLevels } from '../types';
import { configuredMenuItemTransformer } from './configuredMenuItemTransformer';

export const configTransformer = (config: TransformedCmsConfigItemLevels) =>
    Object.keys(config).reduce<ExtendedTransformedCmsConfigItemLevels>(
        (levels, level: string) => ({
            ...levels,
            [level]: Object.keys(config[level]).reduce<ValueOf<ExtendedTransformedCmsConfigItemLevels>>(
                (res, itemId: string) => ({
                    ...res,
                    [itemId]: config[level][itemId].map((item) => {
                        if (Object.prototype.hasOwnProperty.call(OVERRIDE_ENTRY_CONFIG, itemId)) {
                            merge(item, OVERRIDE_ENTRY_CONFIG[itemId]);
                        }
                        return configuredMenuItemTransformer(item);
                    }),
                }),
                {}
            ),
        }),
        {}
    );
